<template>
  <div class="sa-list-component">
    <div class="sa-list-component-body">
      <div class="b-table-sticky-header">
        <b-table sticky-header ref="table" stacked="xl" striped hover :items="getRigheDocumento"
          :fields="fieldsRigheDocumento" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light"
          class="sa-b-table" details-td-class="sa-test-sisto">
          <template #cell(index)="row">
            {{ (currentPage - 1) * perPage + row.index + 1 }}
          </template>
          <template #cell(codiceArticolo)="row">
            <span style="font-weight: 600">{{ row.item.codiceArticolo }}</span>
          </template>
          <template #cell(descrizione)="row">
            <span style="font-weight: 600">{{ row.item.descrizione }}</span>
          </template>
          <template #cell(descrizioneUm)="row">
            <span style="font-weight: 600">{{ row.item.umDescrizione }}</span>
          </template>
          <template #cell(quantita)="row">
            <span style="font-weight: 600">{{ row.item.quantita }}</span>
          </template>
          <template #cell(actions)="row">
            <b-button v-if="row.item.lottiScadenze.length > 0" size="sm"
              variant="btn btn-outline-info waves-effect waves-light width-sm no-text"
              @click="onClickInfoMatricolaLotto(row)">
              <b-icon icon="info"></b-icon>
            </b-button>
          </template>
          <template #row-details="row">

            <template v-if="row.item.lottiScadenze.length > 0">
              <div class="sa-badge-group-lotti">
                <div class="sa-badge" v-for="(rigalotto, index) of row.item.lottiScadenze" :key="index">
                  <span class="sa-badge-label">Codice:</span>
                  <span class="sa-badge-data">{{ rigalotto.codiceArticolo }}</span>
                  <span class="sa-badge-label">Lotto:</span>
                  <span class="sa-badge-data">{{ rigalotto.lottoMatricola }}</span>
                  <span class="sa-badge-label">Quantità:</span>
                  <span class="sa-badge-data">{{ rigalotto.quantita }}</span>
                  <div>
                    <span class="sa-badge-label">Data Scadenza:</span>
                    <span class="sa-badge-data">{{ formatDate(rigalotto.dataOraScadenza) }}</span>
                  </div>
                  <div>
                    <span class="sa-badge-label">Data Produzione:</span>
                    <span class="sa-badge-data">{{ formatDate(rigalotto.dataOraProduzione) }}</span>
                  </div>
                </div>
              </div>
            </template>

          </template>
        </b-table>
      </div>
    </div>
    <div class="sa-list-component-footer">
      <contabilita-documento-riga-documento-modal-component ref="cmpContabilitaDocumentoRigaDocumentoModalComponent"
        :righeDocumento="getRigheDocumento" />
    </div>
  </div>
</template>

<script>
import ContabilitaDocumentoRigaDocumentoModalComponent from "./ContabilitaDocumentoRigaDocumentoModalComponent.vue";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import MagazzinoMixins from "../../magazzino/mixins/MagazzinoMixins";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  mixins: [ContabilitaMixin, MagazzinoMixins, UtilityMixin],
  components: { ContabilitaDocumentoRigaDocumentoModalComponent },

  computed: {
    getRigheDocumento() {
      return [...this.righeDocumento];
    },
  },
  data() {
    return {
      currentPage: 1,
      rows: 0,
      perPage: 100,
      righeDocumento: [],
      pathResource: "/contabilitadocumentorighe",
      rowRigaDocumentoSelezionataIndex: null,
      fieldsRigheDocumento: [
        {
          label: "N.",
          key: "index",
          thStyle: "width: 3rem",
        },
        {
          label: "Codice",
          key: "codiceArticolo",
          sortable: false,
          thStyle: "width: rem",
        },
        {
          label: "Descrizione",
          key: "descrizione",
          sortable: false,
        },
        {
          label: "U.M.",
          key: "descrizioneUm",
          sortable: false,
          thStyle: "width: 3rem",
        },
        {
          label: "Q.tà",
          key: "quantita",
          sortable: false,
          thStyle: "width: 3rem",
        },
        {
          label: "Pr. Unitario",
          key: "prezzoUnitario",
          sortable: true,
          thStyle: "width: 7rem",
          formatter: function (value) {
            if (value) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            } else if (value === 0) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            }
            return value;
          },
        },
        {
          label: "Sconto",
          key: "sconto",
          sortable: false,
          thStyle: "width: 3rem",
          formatter: function (value) {
            if (value) {
              value = value.toLocaleString("it-IT", { style: "percent" });
            } else if (value === 0) {
              value = value.toLocaleString("it-IT", { style: "percent" });
            }
            if (value > 0 && value <= 1) {
              value = value * 100;
              value = value.toLocaleString("it-IT", { style: "percent" });
            }

            return value;
          },
        },
        {
          label: "Tot. Riga",
          key: "totaleRiga",
          sortable: true,
          thStyle: "width: 7rem",
          formatter: function (value) {
            if (value) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            } else if (value === 0) {
              value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
            }
            return value;
          },
        },
        { class: "sa-table-column-action-double", key: "actions", label: "" },
      ],
      matricoleFields: [
        {
          key: "codiceArticolo",
          label: "Codice Articolo",
        },
        {
          key: "matricola",
          label: "Matricola",
        },
        {
          key: "actions",
          label: "",
        },
      ],
      lottiFields: [
        {
          key: "codiceArticolo",
          label: "Articolo",
        },
        {
          key: "lotto",
          label: "Lotto",
        },
        {
          key: "dataOraScadenza",
          label: "Data Ora Scadenza",
        },
        {
          key: "dataOraProduzione",
          label: "Data Ora Produzione",
        },
        {
          key: "actions",
          label: "",
        },
      ],
    };
  },
  mounted() { },
  watch: {},
  methods: {
    init(jsonData) {
      this.righeDocumento = jsonData.righeDocumento;
    },
    onClickInfoMatricolaLotto(row) {
      this.rowRigaDocumentoSelezionataIndex = row.index;
      row.toggleDetails();
    },
  },
};
</script>

<style>
.sa-badge-group-lotti {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 15px;
}
</style>
